
export const compareDateFormat = 'YYYY-MM-DD';
